import { Map } from '../language/models';
import { Language, Message } from './models';
import { TextDirection } from './textDirection';
import { defaultLanguages } from './defaultLanguages';


export type LocaleState = {
  /**
   * The list of languages into which portal messages have been translated.
   */
  portalLanguages: Map<Language>;
  /**
   * BCP 47 encoded language/region string.
   */
  readonly lang: Language;
  readonly textDirection: TextDirection;
  // Object allowing lookup by language, then by translation key
  // Like so: { "en-US": { "key1": { message1 }, "key2": { message2 } } }
  readonly translations: Map<Map<Message>>;
};

export const defaultLocaleState = {
  portalLanguages: defaultLanguages,
  lang: defaultLanguages['en'],
  textDirection: TextDirection.LTR,
} as LocaleState;
